
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic01 as ObiLogic01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-01.js';
 
 
 

 
 export const ObiLogic01 = createComponent({
   react: React,
   tagName: 'obi-logic-01',
   elementClass: ObiLogic01Element,
   events: {
     
   }
  });
 
 